import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import ErrorTooltip from 'components/lib/error_tooltip';
import KeypressEventHandler from 'components/lib/dom_controls/lib/keypress_event_handler';

export default class ApiTokenNameEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.initialValue,
    };

    _.bindAll(this, ['handleBlur', 'handleCancel', 'handleChange', 'handleSubmit']);
  }

  componentDidMount() {
    this.inputElement.focus();
    this.inputElement.select();
  }

  render() {
    const formKeypressHandler = new KeypressEventHandler(null, this.handleCancel, { isInputField: true });

    return (
      <form {...formKeypressHandler.reactAttributes()} onBlur={this.handleBlur} onSubmit={this.handleSubmit}>
        <div className="apiTokenNameEditor-input-container">
          <ErrorTooltip errors={this.props.errors}>
            <div className="apiTokenNameEditor-error">
              <input
                className="editableField apiTokenNameEditor-input"
                onChange={this.handleChange}
                readOnly={this.props.isDisabled}
                ref={node => (this.inputElement = node)}
                value={this.state.value}
              />
            </div>
          </ErrorTooltip>
        </div>
      </form>
    );
  }

  handleBlur() {
    if (this.props.onBlur) {
      this.props.onBlur(this.state.value);
    }
  }

  handleCancel() {
    this.setState({ value: this.props.initialValue });

    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleChange(evt) {
    this.setState({ value: evt.target.value });
  }

  handleSubmit(evt) {
    evt.preventDefault(); // prevent reload on Enter
    if (this.props.onSubmit) {
      this.props.onSubmit(this.state.value);
    }
  }
}

ApiTokenNameEditor.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
  initialValue: PropTypes.string,
  isDisabled: PropTypes.bool,

  onBlur: PropTypes.func,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/api_tokens/api_token_name_editor.jsx